import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import style from './index.scss';

class RangedDtPicker extends React.Component {
  onDateRangeChange = (rangeNo) => {
    let { startDate, endDate } = this.props;

    switch (rangeNo) {
      case 1:
        startDate = moment().subtract(7, 'days').add(1, 'days');
        break;
      case 2:
        startDate = moment().subtract(30, 'days').add(1, 'days');
        break;
      case 3:
        startDate = moment().subtract(90, 'days').add(1, 'days');
        break;
      case 4:
        startDate = moment().subtract(180, 'days').add(1, 'days');
        break;
      case 5:
        startDate = moment().subtract(360, 'days').add(1, 'days');
        break;
      default:
        break;
    }

    this.props.onDateChange(startDate, moment(), rangeNo);
  };

  onDatesChange = (e, picker) => {
    this.props.onDateChange(picker.startDate, picker.endDate, -1);
  };

  getDateFormated = (date, format = 'DD/MM/YYYY') => {
    return moment(date, 'YYYY-MM-DDThh:mm:ss.000Z').format(format);
  };

  render() {
    const { activeRangeNo, startDate, endDate } = this.props;

    if (!activeRangeNo || !startDate || !endDate) {
      return null;
    }

    return (
      <div className={style.wrapper}>
        <span
          className={classnames(
            style.presetSpan,
            activeRangeNo == 1 ? style.presetSpanActive : ''
          )}
          onClick={() => {
            this.onDateRangeChange(1);
          }}>
          7D
        </span>
        <span
          className={classnames(
            style.presetSpan,
            activeRangeNo == 2 ? style.presetSpanActive : ''
          )}
          onClick={() => {
            this.onDateRangeChange(2);
          }}>
          30D
        </span>
        <span
          className={classnames(
            style.presetSpan,
            activeRangeNo == 3 ? style.presetSpanActive : ''
          )}
          onClick={() => {
            this.onDateRangeChange(3);
          }}>
          90D
        </span>
        <span
          className={classnames(
            style.presetSpan,
            activeRangeNo == 4 ? style.presetSpanActive : ''
          )}
          onClick={() => {
            this.onDateRangeChange(4);
          }}>
          180D
        </span>
        <span
          className={classnames(
            style.presetSpan,
            activeRangeNo == 5 ? style.presetSpanActive : ''
          )}
          onClick={() => {
            this.onDateRangeChange(5);
          }}>
          360D
        </span>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onApply={this.onDatesChange}
          containerClass={style.datePicker}
          applyClass={classnames(style.applyBtn)}
          locale={{ format: 'DD/MM/YYYY' }}>
          <i className="fa fa-calendar"></i>&nbsp;
          <span>
            {startDate.format('DD/MM/YYYY')} - {endDate.format('DD/MM/YYYY')}
          </span>
          &nbsp;
          <b className="fa fa-chevron-down"></b>
        </DateRangePicker>
      </div>
    );
  }
}

RangedDtPicker.propTypes = {
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object.isRequired,
  activeRangeNo: PropTypes.number,
  onDateChange: PropTypes.func.isRequired,
  useRedux: PropTypes.bool.isRequired
};

RangedDtPicker.defaultProps = {
  useRedux: false
};

export default RangedDtPicker;
